export const uploadFile = (file, object_name) => {
  return getPresignedUploadUrl(object_name, file.type).then((presigned_url) => {
    return fetch(presigned_url, {
      method: "PUT",
      body: file,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Upload to presigned url failed" + response.text());
        }
        return;
      })
  });
};

const getPresignedUploadUrl = (object_name, content_type) => {
  const url =
    "https://kodexs1t24.execute-api.us-west-2.amazonaws.com/Stage/getPresignedUploadUrl";
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ object_name: object_name, content_type: content_type }),
  };
  return fetch(url, requestOptions)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Unable to get presigned url for upload");
      }
      return response.json();
    })
    .then((data) => {
      return data.presigned_url;
    });
};
